import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAccountSelector } from 'src/hooks';

export const CompletedAccountGuard = () => {
  const { account } = useAccountSelector();
  const location = useLocation();

  if (account?.accountId && account.type.isEntity && !account.isEntityAccountTypeActive) {
    return location.pathname.includes('/account-status') ? <Outlet /> : <Navigate to={`/complete-account`} />;
  }

  if (account?.accountId && account.lastFailedLinkAttemptError) {
    return location.pathname.includes('/account-status') ? <Outlet /> : <Navigate to={'/link-account'} />;
  }

  if (account?.accountId) {
    return <Outlet />;
  }

  return <Navigate to={`/complete-account`} />;
};
